import {
  BookedLegDocumentUpdateInt,
  PassengerUpdateDocumentInt,
} from '@app/interfaces/requiredDocuments.interface'
import { PNRLookupAWSInt } from '@app/interfaces/reservation-aws.interface'
import { ReqBoardingPass } from '@app/models/micro/request/reqBoardingPass.model'
import { RequestContactability } from '@app/models/micro/request/requestContactability.model'
import { RequestMicroModel } from '@app/models/micro/request/requestMicro.model'
import { RequestPassengerListStandby } from '@app/models/micro/request/requestPassengerListStandby.model'
import { RequestRequireDocumentsModel } from '@app/models/micro/request/requestRequireDocumentsModel.model'
import { Reservation } from '@app/models/micro/reservation.model'
import { RequestUpdateDocuments } from '@app/models/micro/updateDocuments.model'
import { RequestPecTab } from '@app/models/micro/request/requestPecTab.model'
import { RequestFlightDetailsModel } from '@models/micro/request/requestFlightDetailsModel.model'
import { RespBoardingPass } from '@app/models/micro/response/respBoardingPass.model'
import { RespDoCheckIn } from '@app/models/micro/response/respDoCheckIn.model'
import { RequestEligibilityIrops } from '@app/models/micro/request/requestEligibilityIrops.model'
import { RequestSearchFlightIrops } from "@app/models/micro/request/requestSearchFlightIrops.model";
import { FlightSummaryIrops } from "@app/models/micro/flight-summary-irops.model";
import moment from "moment";
import {CabinInfo, CabinResponse, CabinRquest} from "@app/interfaces/micro/cabin.interface";
import { Passenger } from '@app/models/micro'
export class ApiMapper {
  constructor() {}

  static requestEligibility(reservation: PNRLookupAWSInt, lookup: Reservation) {
    let requestMicroModel = new RequestMicroModel(reservation, lookup)
    return requestMicroModel
  }

  static requestRequireDocuments(reservation: Reservation) {
    let requestRequireDocumentsModel = new RequestRequireDocumentsModel(
      reservation,
    )
    return requestRequireDocumentsModel
  }

  static requestFlightDetails(reservation: Reservation) {
    let requestFlightDetailsModel = new RequestFlightDetailsModel(reservation)
    return requestFlightDetailsModel
  }

  static requestListstandby(reservation: Reservation) {
    let request = new RequestPassengerListStandby(reservation)
    return request
  }

  static mapPassengerListUpgrade(reservation: Reservation) {
    let requestMicroModel = new RequestPassengerListStandby(reservation)
    return requestMicroModel
  }

  static requestBoardingPass(reservation: Reservation) {
    let requestBoardingPass = new ReqBoardingPass(reservation)
    return requestBoardingPass
  }

  static respBoardingPass(resp: any) {
    let respBoardingPass = new RespBoardingPass(resp)
    return respBoardingPass
  }

  static requestUpdateDocuments(
    bk: BookedLegDocumentUpdateInt[],
    passenger: PassengerUpdateDocumentInt[],
    reservation: Reservation,
    tripType: string,
  ) {
    let request = new RequestUpdateDocuments(
      bk,
      passenger,
      reservation,
      tripType,
    )
    return request
  }

  static mapContactabilityDigital(reservation: Reservation) {
    const passengers = reservation.passengers.filter(
      (passenger) => passenger.checkinSelected && passenger.sendContactability,
    )
    const listPassengers = passengers.map((passenger) => {
      return new RequestContactability(passenger, reservation.pnr)
    })
    return listPassengers
  }

  static requestPecTab(reservation: Reservation, reprintBp: boolean) {
    let requestMicroModel = new RequestPecTab(reservation, reprintBp)
    return requestMicroModel
  }

  static respDoCheckIn(resp: any) {
    if (this.validateCheckin(resp)) {
      return new RespDoCheckIn(resp)
    } else {
      throw {
        message: 'error',
      }
    }
  }

  static validateCheckin(response) {
    return response.passengers.every((p) => {
      const [element] = p?.checkinStatusBySegment
      return element?.checkinStatus || element.onStandByList
    })
  }

  //#region Irops
  static mapEligibilityIrops(reservation: Reservation) {
    let requestMicroModel = new RequestEligibilityIrops(reservation)
    return requestMicroModel
  }
  //#endregion Irops

  static getResquestAssingSeat(reservation: Reservation, newFlight?: FlightSummaryIrops) {
    const newFlightDepartureDate = newFlight?.departureDateTime
      ?? newFlight?.segments?.[0]?.departureDateTime;

    const seatInfo = reservation.flightSummary.segments
    .filter(segment => segment.isCancelOag || segment.isChangeOag)
      .map((segment, index) => {
        if (!segment?.flightsNewInfo) return null

        const seats = reservation.passengers
        .map(passenger => {
          const seat = passenger.seats?.find(
            s => s.segmentCode === segment.segmentCode
          );
          return seat?.seatCode ? { seatCode: seat.seatCode } : null;
        })

        const segmentNewFlight = newFlight?.segments?.[index];
        const departureDate = segmentNewFlight?.departureDateTime
          ?? newFlightDepartureDate
          ?? segment.flightsNewInfo.originalDepartureTime;

        return {
          newSegment: {
            departure: segment.departureAirport,
            arrival: segment.arrivalAirport,
            departureDate,
          },
          seats,
        }
      })

    return {
      seatInfo,
    }
  }

    static mapSearchFlightIrops(reservation: Reservation,departureDate: string, cabin?: CabinInfo[]) {
        let requestMicroModel = new RequestSearchFlightIrops(reservation,departureDate, cabin);
        return requestMicroModel;
    }
    //#endregion Irops

  static requestCabin(reservation: PNRLookupAWSInt): CabinRquest {
    return {
      legCollection: reservation.bookedLegCollection.map(legElement => {
        const {legCode, legRegion: region, segments} = legElement;
        const [firstSegment, ...nextSegments] = segments;
        const leg = legCode.substring(0,7);
        const lastSegment = nextSegments && nextSegments.length > 0 ? nextSegments[nextSegments.length - 1] : firstSegment;

        return {
          leg,
          region,
          subRegionDestination: lastSegment.arrivalAirportRegion,
          subRegionOrigin: firstSegment.departureAirportRegion,
          departureDate: moment(firstSegment.departureDateTime).format('YYYY-MM-DD'),
          departureAirportCountry: firstSegment.departureCountry,
          arrivalAirportCountry: lastSegment.arrivalCountry
        }
      })
    }
  }
  static respCabin(response: CabinResponse) {
    return response.cabins;
  }

  static updateDocumentsPostCki(reservation: Reservation, passenger: Passenger, type: string) {
    const segment = reservation.flightSummary.currentSegment;
    const passengerId =
      passenger.passengerIds?.length > 0 ? passenger.passengerIds[0].id : passenger.passengerId;
    return {
      reservationCode: reservation.pnr,
      segment: {
        bookingClass: segment.bookingClass,
        departureAirport: segment.departureAirport,
        departureDateTime: segment.departureDateTime,
        operatingCarrier: segment.operatingCarrier,
        operatingFlightCode: segment.operatingFlightCode,
        segmentCode: segment.segmentCode,
        segmentStatusCode: segment.segmentStatusCode,
      },
      passengers: [
        {
          passengerNameNumber: passenger.nameRefNumber,
          passengerId: passengerId,
          firstName: passenger.firstName,
          lastName: passenger.lastName,
          addDOCV: true,
          type,
        },
      ],
    };
  }
}
